import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { memo } from "react";
import { useField } from "react-final-form";
import isEqual from "lodash/isEqual";
import { WysiwygInput } from "@vk-hr-tek/ui/input";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function WysiwygInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else WysiwygInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const handleChange = (input, onChange)=>(body)=>{
        input.onChange(body.data);
        null == onChange || onChange(body);
    };
const handleBlur = (input)=>()=>{
        input.onBlur();
    };
const handleFocus = (input)=>()=>{
        input.onFocus();
    };
const arePropsEqual = (oldProps, newProps)=>isEqual(oldProps, newProps);
const WysiwygInput_WysiwygInput = /*#__PURE__*/ memo((t0)=>{
    const $ = c(85);
    let apiUrl;
    let bgcolor;
    let checkEditorContainsMention;
    let debounceTimeout;
    let editable;
    let envVars;
    let getAttachmentUrl;
    let getCurrentMediaIds;
    let getCurrentMentionsData;
    let handleSendClick;
    let hideSubmitButton;
    let initialValue;
    let label;
    let loadFile;
    let maxCharLimit;
    let name;
    let onChange;
    let onUploadError;
    let placeholder;
    let rest;
    let searchMentions;
    let showCharLimitCounter;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let validateArray;
    let withoutPaddings;
    if ($[0] !== t0) {
        const { config: t9, name: t10, onChange: t11, placeholder: t12, label: t13, required: t14, tooltip: t15, loadFile: t16, getAttachmentUrl: t17, searchMentions: t18, onUploadError: t19, validateArray: t20, getCurrentMediaIds: t21, getCurrentMentionsData: t22, checkEditorContainsMention: t23, handleSendClick: t24, onFocusEditor, focusMode: t25, debounceTimeout: t26, maxCharLimit: t27, showCharLimitCounter: t28, editable: t29, hideSubmitButton: t30, bgcolor: t31, withoutPaddings: t32, apiUrl: t33, envVars: t34, isSubmitting: t35, showErrors: t36, initialValue: t37, flat: t38, stickyToolbar: t39 } = t0, t40 = _object_without_properties(t0, [
            "config",
            "name",
            "onChange",
            "placeholder",
            "label",
            "required",
            "tooltip",
            "loadFile",
            "getAttachmentUrl",
            "searchMentions",
            "onUploadError",
            "validateArray",
            "getCurrentMediaIds",
            "getCurrentMentionsData",
            "checkEditorContainsMention",
            "handleSendClick",
            "onFocusEditor",
            "focusMode",
            "debounceTimeout",
            "maxCharLimit",
            "showCharLimitCounter",
            "editable",
            "hideSubmitButton",
            "bgcolor",
            "withoutPaddings",
            "apiUrl",
            "envVars",
            "isSubmitting",
            "showErrors",
            "initialValue",
            "flat",
            "stickyToolbar"
        ]);
        t1 = t9;
        name = t10;
        onChange = t11;
        placeholder = t12;
        label = t13;
        t2 = t14;
        t3 = t15;
        loadFile = t16;
        getAttachmentUrl = t17;
        searchMentions = t18;
        onUploadError = t19;
        validateArray = t20;
        getCurrentMediaIds = t21;
        getCurrentMentionsData = t22;
        checkEditorContainsMention = t23;
        handleSendClick = t24;
        t4 = t25;
        debounceTimeout = t26;
        maxCharLimit = t27;
        showCharLimitCounter = t28;
        editable = t29;
        hideSubmitButton = t30;
        bgcolor = t31;
        withoutPaddings = t32;
        apiUrl = t33;
        envVars = t34;
        t5 = t35;
        t6 = t36;
        initialValue = t37;
        t7 = t38;
        t8 = t39;
        rest = t40;
        $[0] = t0;
        $[1] = apiUrl;
        $[2] = bgcolor;
        $[3] = checkEditorContainsMention;
        $[4] = debounceTimeout;
        $[5] = editable;
        $[6] = envVars;
        $[7] = getAttachmentUrl;
        $[8] = getCurrentMediaIds;
        $[9] = getCurrentMentionsData;
        $[10] = handleSendClick;
        $[11] = hideSubmitButton;
        $[12] = initialValue;
        $[13] = label;
        $[14] = loadFile;
        $[15] = maxCharLimit;
        $[16] = name;
        $[17] = onChange;
        $[18] = onUploadError;
        $[19] = placeholder;
        $[20] = rest;
        $[21] = searchMentions;
        $[22] = showCharLimitCounter;
        $[23] = t1;
        $[24] = t2;
        $[25] = t3;
        $[26] = t4;
        $[27] = t5;
        $[28] = t6;
        $[29] = t7;
        $[30] = t8;
        $[31] = validateArray;
        $[32] = withoutPaddings;
    } else {
        apiUrl = $[1];
        bgcolor = $[2];
        checkEditorContainsMention = $[3];
        debounceTimeout = $[4];
        editable = $[5];
        envVars = $[6];
        getAttachmentUrl = $[7];
        getCurrentMediaIds = $[8];
        getCurrentMentionsData = $[9];
        handleSendClick = $[10];
        hideSubmitButton = $[11];
        initialValue = $[12];
        label = $[13];
        loadFile = $[14];
        maxCharLimit = $[15];
        name = $[16];
        onChange = $[17];
        onUploadError = $[18];
        placeholder = $[19];
        rest = $[20];
        searchMentions = $[21];
        showCharLimitCounter = $[22];
        t1 = $[23];
        t2 = $[24];
        t3 = $[25];
        t4 = $[26];
        t5 = $[27];
        t6 = $[28];
        t7 = $[29];
        t8 = $[30];
        validateArray = $[31];
        withoutPaddings = $[32];
    }
    let t9;
    if ($[33] !== t1) {
        t9 = void 0 === t1 ? {
            plugins: {
                selectAllPlugin: {
                    value: true,
                    withDivider: true
                },
                formatHeadingPlugin: {
                    heading: true,
                    fontColor: true,
                    backgroungColor: true,
                    withDivider: true
                },
                formatTextPlugin: {
                    bold: true,
                    italic: true,
                    underline: true,
                    strikethrough: true,
                    code: true,
                    superscript: true,
                    subscript: true,
                    withDivider: true
                },
                listAndFormatPlugin: {
                    align: true,
                    list: true,
                    indent: true,
                    withDivider: true
                },
                linkAndTablePlugin: {
                    link: true,
                    table: true,
                    reference: true,
                    codeBlock: true,
                    quote: true,
                    symbols: true,
                    mention: true,
                    withDivider: true
                },
                mediaPlugin: {
                    singeImage: true,
                    imagesGallery: true,
                    video: true,
                    file: true,
                    withDivider: true
                },
                undoRedoPlugin: true,
                trackMediaIdsAndMentionsPlugin: true
            },
            mode: "default"
        } : t1;
        $[33] = t1;
        $[34] = t9;
    } else t9 = $[34];
    const config = t9;
    const required = void 0 === t2 ? false : t2;
    const tooltip = void 0 === t3 ? null : t3;
    const focusMode = void 0 === t4 ? "manual" : t4;
    const isSubmitting = void 0 === t5 ? false : t5;
    const showErrors = void 0 === t6 ? true : t6;
    const flat = void 0 === t7 ? false : t7;
    const stickyToolbar = void 0 === t8 ? true : t8;
    const composeValidators = _temp;
    let t10;
    if ($[35] !== validateArray) {
        t10 = validateArray || [];
        $[35] = validateArray;
        $[36] = t10;
    } else t10 = $[36];
    let t11;
    if ($[37] !== t10) {
        t11 = composeValidators(t10);
        $[37] = t10;
        $[38] = t11;
    } else t11 = $[38];
    let t12;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = {
            value: true,
            touched: true,
            error: true
        };
        $[39] = t12;
    } else t12 = $[39];
    let t13;
    if ($[40] !== rest || $[41] !== t11) {
        t13 = _object_spread({
            validate: t11,
            subscription: t12
        }, rest);
        $[40] = rest;
        $[41] = t11;
        $[42] = t13;
    } else t13 = $[42];
    const { input, meta } = useField(name, t13);
    const helperText = meta.touched && "string" == typeof meta.error ? meta.error : void 0;
    let t14;
    if ($[43] !== input || $[44] !== onChange) {
        t14 = handleChange(input, onChange);
        $[43] = input;
        $[44] = onChange;
        $[45] = t14;
    } else t14 = $[45];
    let t15;
    if ($[46] !== input) {
        t15 = handleBlur(input);
        $[46] = input;
        $[47] = t15;
    } else t15 = $[47];
    let t16;
    if ($[48] !== input) {
        t16 = handleFocus(input);
        $[48] = input;
        $[49] = t16;
    } else t16 = $[49];
    const t17 = meta.touched && !!meta.error;
    let t18;
    if ($[50] !== apiUrl || $[51] !== bgcolor || $[52] !== checkEditorContainsMention || $[53] !== config || $[54] !== debounceTimeout || $[55] !== editable || $[56] !== envVars || $[57] !== flat || $[58] !== focusMode || $[59] !== getAttachmentUrl || $[60] !== getCurrentMediaIds || $[61] !== getCurrentMentionsData || $[62] !== handleSendClick || $[63] !== helperText || $[64] !== hideSubmitButton || $[65] !== initialValue || $[66] !== input || $[67] !== isSubmitting || $[68] !== label || $[69] !== loadFile || $[70] !== maxCharLimit || $[71] !== onUploadError || $[72] !== placeholder || $[73] !== required || $[74] !== searchMentions || $[75] !== showCharLimitCounter || $[76] !== showErrors || $[77] !== stickyToolbar || $[78] !== t14 || $[79] !== t15 || $[80] !== t16 || $[81] !== t17 || $[82] !== tooltip || $[83] !== withoutPaddings) {
        t18 = /*#__PURE__*/ jsx(WysiwygInput, _object_spread_props(_object_spread({}, input), {
            initialValue: initialValue,
            apiUrl: apiUrl,
            envVars: envVars,
            config: config,
            onChange: t14,
            onBlur: t15,
            onFocus: t16,
            placeholder: placeholder,
            label: label,
            required: required,
            tooltip: tooltip,
            error: t17,
            helperText: helperText,
            loadFile: loadFile,
            getAttachmentUrl: getAttachmentUrl,
            searchMentions: searchMentions,
            onUploadError: onUploadError,
            getCurrentMediaIds: getCurrentMediaIds,
            getCurrentMentionsData: getCurrentMentionsData,
            checkEditorContainsMention: checkEditorContainsMention,
            handleSendClick: handleSendClick,
            focusMode: focusMode,
            debounceTimeout: debounceTimeout,
            maxCharLimit: maxCharLimit,
            showCharLimitCounter: showCharLimitCounter,
            editable: editable,
            hideSubmitButton: hideSubmitButton,
            bgcolor: bgcolor,
            withoutPaddings: withoutPaddings,
            isSubmitting: isSubmitting,
            showErrors: showErrors,
            flat: flat,
            stickyToolbar: stickyToolbar
        }));
        $[50] = apiUrl;
        $[51] = bgcolor;
        $[52] = checkEditorContainsMention;
        $[53] = config;
        $[54] = debounceTimeout;
        $[55] = editable;
        $[56] = envVars;
        $[57] = flat;
        $[58] = focusMode;
        $[59] = getAttachmentUrl;
        $[60] = getCurrentMediaIds;
        $[61] = getCurrentMentionsData;
        $[62] = handleSendClick;
        $[63] = helperText;
        $[64] = hideSubmitButton;
        $[65] = initialValue;
        $[66] = input;
        $[67] = isSubmitting;
        $[68] = label;
        $[69] = loadFile;
        $[70] = maxCharLimit;
        $[71] = onUploadError;
        $[72] = placeholder;
        $[73] = required;
        $[74] = searchMentions;
        $[75] = showCharLimitCounter;
        $[76] = showErrors;
        $[77] = stickyToolbar;
        $[78] = t14;
        $[79] = t15;
        $[80] = t16;
        $[81] = t17;
        $[82] = tooltip;
        $[83] = withoutPaddings;
        $[84] = t18;
    } else t18 = $[84];
    return t18;
}, arePropsEqual);
function _temp(validators) {
    return (value, allValues)=>{
        const result = validators.reduce((error, validator)=>error || (null == validator ? void 0 : validator(value, allValues)), void 0);
        return result;
    };
}
export { WysiwygInput_WysiwygInput as WysiwygInput };
